"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { AmbientFloatingLines } from "@/components/ui/atoms/ambient-floating-lines";
import { endExerciseSession } from "@/lib/analytics/exercise-session";

/** `/learn` itself shows the full ambient; deeper routes mute it for readability. */
function isListRoute(pathname: string): boolean {
  return pathname === "/learn" || pathname === "/learn/";
}

export default function LearnLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const intensity = isListRoute(pathname) ? "default" : "muted";

  /*
    Revenir dans `/learn`, c'est avoir quitté le studio.

    La session d'exercice n'était fermée que par le chargement de l'exercice
    suivant : `durationMs` comptait donc tout le temps passé entre les deux, y
    compris à relire son parcours ou à fouiller la bibliothèque. Cette coque
    est la seule surface de la section qui survive à la navigation d'un écran
    de `/learn` à l'autre, donc la seule à pouvoir dire « le studio n'est plus
    à l'écran » sans le dire quatre fois.

    Au montage seulement : la pré-séance ouvre la session juste avant de
    pousser vers `/studio`, et cette coque est déjà montée à ce moment-là.
    L'appel est sans effet quand aucune session ne court.
  */
  useEffect(() => {
    endExerciseSession("left");
  }, []);

  return (
    <div className="relative flex-1 overflow-y-auto">
      <AmbientFloatingLines intensity={intensity} />
      <div className="relative z-10">{children}</div>
    </div>
  );
}
